<template>
  <div class="player-icon relative z-1001">
    <div class="absolute w-[200px] left-[654px] top-[-162px] text-center">
      <div class="name font-bold text-xs">{{ name }}
        <player-setup-license-icon class="player-icon" :license="license" />
      </div>
      <div :class="['icon', icon]"></div>
    </div>
  </div>
</template>

<script src="./player-setup-icon.js"></script>
<style lang="scss" src="./player-setup-icon.scss"></style>
